import StoredLayout from '../../layouts/StoredLayout'
import Tabs from './Tabs'
export default StoredLayout(Tabs)



// WEBPACK FOOTER //
// ./src/ui-elements/tabs/index.js